import { useGetMessagesQuery } from "./messageApiSlice"
import Message from "./Message"
import useAuth from "../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
const MessagesList = ({active,  q}) => {
    const {groupId, type} = useParams()
    const {  isTeacher, isAdmin } = useAuth()
    const {
        data: messages,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetMessagesQuery('messagesList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: false
    })




    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess ) {
        const { ids, entities } = messages
       
        let filteredIds = []
        if((groupId!=='0')|| active ||  q!==''){
            filteredIds=[...ids].filter(messageId =>{
                const message =  entities[messageId]
             return ((groupId==='0' || message.group?._id === groupId ) &&
                    (!active || ( message.active &&  Date.parse(message.toDate) - Date.parse(new Date())>0 )) &&
                    (q==='' ||((message.title.toLowerCase().indexOf(q.toLowerCase()) >-1)||(message.body?.toLowerCase().indexOf(q.toLowerCase()) >-1) )))

            })
        }else
            {
                filteredIds = [...ids]
            }
        let addButtn= null
        if(isAdmin || isTeacher){
        addButtn = (
        <Link to={`/${type}/${groupId}/messages/new`}>
 <FontAwesomeIcon icon={faAdd} />הוספת הודעה
        </Link>
        
      )
        }

        const tableContent = ids?.length && filteredIds.map(messageId => <Message key={messageId} messageId={messageId} />)

        content = (
            <>
            {addButtn}
            <table className={`table table--messages ${(isAdmin || isTeacher)&& "table--messages--admin"} `}>
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th message__title">הודעה</th>
                        <th scope="col" className="table__th message__title">קבוצה</th>
                        <th scope="col" className="table__th message__dates">זמן נותר</th>
                        <th scope="col" className="table__th message__dates">ספציפית  </th>
                        <th scope="col" className="table__th message__dates">תגובות  </th>
                        <th scope="col" className="table__th message__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default MessagesList